/**
 * #35 (ESERV2-1435) — human label for a persisted vendor stock reading.
 *
 * A stock number without its branch is meaningless, and fk_branch_id can
 * legitimately be NULL while stock_level is not (the FK is ON DELETE SET NULL:
 * a purged branch keeps the last reading). So: number + branch when we have
 * both, number + an explicit "branch unknown" marker when we do not, and null
 * when there is no reading at all — the caller hides the row entirely.
 */
export const vendorStockLabel = (vendor, unknownBranchText) => {
  if (vendor == null || vendor.stock_level == null) return null;
  const qty = Number(vendor.stock_level);
  if (!Number.isFinite(qty)) return null;
  return vendor.stock_branch_label
    ? `${qty} @ ${vendor.stock_branch_label}`
    : `${qty} (${unknownBranchText})`;
};
